import '~/js/libs/slick-carousel';

const $sliderTimeline = $('.js-slick-slider-timeline');
const $statusSliderTimeline = $('.js-slick-slider-timeline-counter');

const largeResolution = 1200;   // bootstrap value for Large devices Desktops
// const mediumResolution = 992;   // bootstrap value for Medium devices Desktops
const sliderResolution = largeResolution;

if ($(window).width() < sliderResolution) {
    $sliderTimeline.find('.js-not-load-for-mobile img').removeAttr('data-lazy');
}

$sliderTimeline.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderTimeline.text(i + '/' + slick.slideCount);
});

const slider = $sliderTimeline.slick({
    centerPadding: '0',
    lazyLoad: 'progressive',
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 600,
    prevArrow: $('.js-prev-slide-in-slider-timeline'),
    nextArrow: $('.js-next-slide-in-slider-timeline')
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    const nextImg = $(slick.$slides[nextSlide]).find('img')[0];
    const srcImg = nextImg.dataset.src;

    nextImg.src = srcImg;
    nextImg.addEventListener('load', () => {
        nextImg.style.opacity = 1;
    });
});
